import React, { useEffect, useState } from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import axios from "axios";
import { Link } from 'react-router-dom';
import api, { baseURL } from "../../API/api.url";

const Portfolio = () => {
  const [portfolios, setPortfolios] = useState([]);

  const getAllPortfolios = async () => {
    try {
      console.log("Fetching from:", `${baseURL}${api.portfolio.getAllPortfolios.url}`);
      const response = await axios.get(`${baseURL}${api.portfolio.getAllPortfolios.url}`);
      console.log("RES API", response.data);

      if (Array.isArray(response.data)) {
        setPortfolios(response.data);
        console.log("Portfolios set:", response.data);
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching portfolios:", error);
    }
  };



  useEffect(() => {
    getAllPortfolios();
  }, []);

  return (
    <>
      <Navbar />
      <div className="main-section">
        <div className="portfolio-main py-5">
          <div className="container">
            <div className="portfolio-title col-md-8 mx-auto text-center mb-4">
              <span className="text-uppercase text-muted">My Portfolio</span>
              <h2 className="fw-bold">
                A Showcase of Innovation and <b>Excellence</b>
              </h2>
              <p className="mt-3">
                Discover our diverse range of projects that combine creativity, technology, and results-driven strategy to deliver impactful digital experiences.
              </p>
            </div>

            <div className="row">
              {portfolios.length > 0 ? (
                portfolios.map((portfolio) => (
                  <div key={portfolio._id} className="col-12 col-sm-6 col-md-4 mb-4">
                    <Link to={`/projects-details/${portfolio.slug.split("-").slice(0, 5).join("-")}`}
                      className="text-decoration-none text-dark">
                      <img
                        src={`${baseURL}${portfolio.thumbnail}`}
                        alt={portfolio.AppName}
                        style={{ width: "100%", height: "200px", objectFit: "cover" }}
                      />
                      <h5 className="fw-semibold mt-3">
                        {portfolio.slug.split("-").slice(0, 3).join(" ")}
                      </h5>
                      <h5 className="fw-semibold mt-3">{portfolio.AppName}</h5>
                      {console.log((portfolio))}
                      <p className="text-muted small">{portfolio.ShortDescription}</p>
                    </Link>
                  </div>
          
          ))
          ) : (
          <div className="col-12 text-center">
            <p>No portfolios found.</p>
          </div>
              )}
        </div>

      </div>
    </div >
      </div >
  <Footer />
    </>
  );
};

export default Portfolio;
